import Pane from 'components/Common/Pane'
import React from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import ScrollAnchor from 'components/Common/ScrollAnchor'
import AccommodationRoomTile from 'components/AccommodationKit/AccommodationRoomTile'
import Divider from 'LuxKit/Divider'
import AccommodationPackageTile from 'components/AccommodationKit/AccommodationPackageTile'
import AccommodationPackageTileContentArea from 'components/AccommodationKit/AccommodationPackageTileContentArea'
import AccommodationPackageTilePricingArea from 'components/AccommodationKit/AccommodationPackageTilePricingArea'
import AccommodationPackageTileDetails from 'components/AccommodationKit/AccommodationPackageTileDetails'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import AccommodationPackageTileInclusions from 'components/AccommodationKit/AccommodationPackageTileInclusions'
import AccommodationRoomTileDetails from 'components/AccommodationKit/AccommodationRoomTileDetails'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import { useOfferInclusions } from 'hooks/useOfferInclusions'
import InclusionsSection from '../FlashHotel/InclusionsSection'

interface Props {
  packageView: App.OfferPackageOptionView
}

function LastMinutePackageOption(props: Props) {
  const {
    packageView,
  } = props

  const {
    package: pkg,
  } = packageView

  const intl = useIntl()
  const { inclusions, bonusInclusions } = useOfferInclusions(pkg)
  const hasInclusions = bonusInclusions.length > 0 || inclusions.length > 0

  const showMoreText = intl.formatMessage({
    id: '8q3OTve8t0',
    defaultMessage: 'View more inclusions',
    description: 'Toggle text to expand and show more package inclusions',
  })

  const showLessText = intl.formatMessage({
    id: 'FO2bd993YJ',
    defaultMessage: 'View less inclusions',
    description: 'Toggle text to collapse and show fewer package inclusions',
  })

  return (
    <Pane shadow="bottom-small" data-testid="package-option">
      <ScrollAnchor id={pkg.roomType.id} vOffset={rem(80)} />
      <AccommodationRoomTile roomPackage={pkg}>
        <AccommodationRoomTileImage
          roomPackage={pkg}
        />
        <AccommodationRoomTileDetails
          roomPackage={pkg}
        />
      </AccommodationRoomTile>
      <Divider kind="primary" />
      <AccommodationPackageTile>
        <AccommodationPackageTileContentArea>
          <AccommodationPackageTileDetails
            packageNumber={1}
            roomPackage={packageView.package}
          />
          <AccommodationPackageTileInclusions>
            <LargeContentToggle
              maxHeight={208}
              showMoreText={showMoreText}
              showLessText={showLessText}
            >
              {hasInclusions && <InclusionsSection
                inclusions={inclusions}
                bonusInclusions={bonusInclusions}
              />}
            </LargeContentToggle>
          </AccommodationPackageTileInclusions>
        </AccommodationPackageTileContentArea>
        <AccommodationPackageTilePricingArea />
      </AccommodationPackageTile>
    </Pane>
  )
}

export default LastMinutePackageOption
